import { Button } from 'reactstrap';
import '../ReactSearchSelect.css';
import "../GlobalStyles.css";
import { useEffect, useMemo, useState } from 'react';
import Charge from '../../Models/Charge';
import "./Charges.css"
import DriverService from '../../Services/DriverService';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import { useMsal } from '@azure/msal-react';

interface Props{
    chargesArray: Charge[],
    setIsLoading: Function,
    isLoading: boolean,
    deleteChargeById: Function,
}

const UserChargesForm = (props:Props) =>{
    
    const {instance} = useMsal();
    const driverService = useMemo(() => new DriverService(instance), [instance]);


    const [charges, setCharges] = useState<Charge[]>([])

    useEffect(() =>{
        setCharges(props.chargesArray)
        
    }, [props.chargesArray])

    function handleChargeDeletion(chargeId: string){
        Swal.fire({
            title: "Bevestiging",
            text: "Wilt u deze laadbeurt verwijderen?",
           
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Bevestig",
            cancelButtonText: "Annuleer"
          }).then((result) => {
            if (result.isConfirmed) {
                driverService.UpdateCharge(chargeId, 1);
                props.deleteChargeById(chargeId);
              Swal.fire({
                title: "Verwijderd",
                text: "Uw laadbeurt is verwijderd.",
                icon: "success",
                confirmButtonColor: "#3085d6"
              });
            }
          });
    }

function createChargesUI(){
    return (
        <>
            {props.isLoading === false && 
                <div>
                    {props.chargesArray.length === 0 ? 
                        hasNoChargesUI()
                        :
                        (
                            <div style={{ height: "64vh" }}>
                                <p className="cost-overview-monthly">
                                    {calculateMonthlyCost(props.chargesArray)}
                                </p>
                                <div className='cost-overview-container' >
                                    {hasChargesUI}
                                </div>
                            </div>
                        )
                    }
                </div>
            }
        </>
    )
}

var index = 0;

const hasChargesUI = charges.map(charge =>{
    index++;
    return(
        
    <div className='cost-overview-item' key={index}>
        <span>%</span>
        <p>{charge.chargePercentage}</p>
        <p>{getDateInputFormat(charge.chargeDate)}</p>
        <p>{charge.chargeCost.toFixed(2)}</p>
        <span>€</span>
            <Button 
            
                 color={charge.chargePayout?.payoutStatus === 1 ? "secondary":"danger"}
                 className="d-flex justify-content-center align-items-center"
                 style={{height: "35px"}}     
                 onClick={() =>{
                    //Will only execute if part of an existing active payout
                    if(charge.chargePayout?.payoutStatus === 0){
                        handleChargeDeletion(charge.chargeId);
                    }
                    else{
                        toast.info("Laadbeurt is al uitbetaald.")
                    }
                    
                 }}                             
                >
                <i className="fas fa-minus fa-md"></i>
            </Button>
    </div>

          )
})

function hasNoChargesUI(){
    return (
        <>
            <p>Geen laadbeurten binnen deze periode</p>
        </>
    )
}
function getDateInputFormat(newDate: Date): string {
    const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
    const date: Date = new Date(newDate);
    const dateStringFormat: string = `${zeroPad(date.getDate(), 2)}/${zeroPad(date.getMonth() + 1, 2)}/${date.getFullYear()}`;
    return dateStringFormat;
}

function calculateMonthlyCost(chargesArray: Charge[]): string {
    const totalCost = chargesArray.reduce((acc, charge) => acc + charge.chargeCost, 0);
    return `Totaal: €${totalCost.toFixed(2)}`;
}
    return (
        <>
          {createChargesUI()}
        </>
    )
}





export default UserChargesForm